<ng-container *ngIf="showMarketingContent$ | async">
  <div
    *ngIf="marketingContent$ | async as content"
    id="cac-marketing-content-group"
    class="market-content-container"
  >
    <h2 class="center" id="cac-marketing-content-title">
      {{ content.title }}
    </h2>
    <div class="body-black center" id="cac-marketing-content-description">
      <p>{{ content.description }}</p>
    </div>
  </div>
</ng-container>
